// Created by christophe.gaon on 30/01/2017.

let instance;
class GlobalMediator {
  /**
   * install method from plugin
   * @param Vue
   */
  static install(Vue) {
    instance = new GlobalMediator(Vue);
    Vue.mixin({
      data: () => instance.data(),
      methods: {
        emit: (event) => instance.emit(event),
        on: (event, handler) => instance.on(event, handler),
      },
    });
  }

  /**
   * display liste of event on all component
   * @returns {{globalEvent: {BasketEvent}}}
   */
  data() {
    return {
      // globalEvent: this.globalEvent,
    };
  }

  /**
   * Singleton for Global Mediator
   * @param Vue
   */
  constructor(Vue) {
    this.bus = new Vue();
    this.namespace = 'Valtech.Foundation.Events.';
  }

  /**
   * emit wrapper on emit methode
   * @param event {string} event dispatch
   */
  emit(event) {
    this.bus.$emit(this.namespace + event);
  }

  /**
   * on wrapper of $on
   * @param event {string} event listen
   * @param handler {function} handler on the component
   */
  on(event, handler) {
    this.bus.$on(this.namespace + event, handler);
  }
}

export default {
  install: (Vue) => GlobalMediator.install(Vue),
  forTU: () => instance,
};
